import Chart from 'react-apexcharts';

const CustomChartBar = ({ years, amounts }) => {
    // Chart data
    const chartData = {
        series: [{
            name: 'Invoice Amount',
            data: amounts 
        }],
        options: {
            chart: {
                type: 'bar',
                height: 265,
                toolbar: {
                    show: false 
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'flat',
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: years,
                axisBorder: {
                    show: true, // Show the main x-axis line
                },
                axisTicks: {
                    show: true, // Show ticks on the x-axis
                },
            },
            yaxis: {
                labels: {
                    formatter: function (value) {
                        return '€' + (value / 1000) + 'k';
                    }
                },
                axisBorder: {
                    show: true, // Show the main y-axis line
                },
                axisTicks: {
                    show: true, // Show ticks on the y-axis
                },
            },
            grid: {
                show: false, // Disable all grid lines
            },
            fill: {
                opacity: 1,
                colors: ['#008FFB'] // blue color for bars
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(val);
                    }
                }
            }
        },
    };

    return (
        <Chart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={265}
        />
    );
};

export default CustomChartBar;